import axios from "axios";
import { api_s2, app } from "../config";

// S2 API base URL (pymble-apis / FastAPI)
axios.defaults.baseURL = api_s2.baseURL;

// Identify this app to the S2 API
axios.defaults.headers.common["PymbleClientId"] = app.clientId;

/**
 * Our standard http service for http requests
 */
axios.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		const expectedErr =
			error.response &&
			error.response.status >= 400 &&
			error.response.status < 500;

		if (!expectedErr) {
			console.error("httpService error:", error);
		}

		return Promise.reject(error);
	}
);

const httpService = {
	get: axios.get,
	post: axios.post,
	put: axios.put,
	delete: axios.delete,
	head: axios.head,
	request: axios.request,
};

export default httpService;
